// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"33afa1b9","710":"56eab57a","905":"081de6f6"}[chunkId] + ".chunk.js";
};